import { createContext } from 'react';
import { OTELContextProps } from '../../models/context/otel';

export const OTELContext = createContext<Partial<OTELContextProps>>({
  namespace: 'olr',
});
